const reports = {
  users: {
    table: {
      users: 'Utilisateur',
      login: 'Connexion',
      accessLevel: "Niveau d'accès",
      activationDate: "Date d'activation",
      lastLogin: 'Dernière connexion',
      status: 'Statut',
    },
    search: 'Utilisateur / Connexion',
    refreshButton: 'Recherche',
    resetButton: 'Réinitialiser',
    dateFilter: {
      activation: "Date d'activation",
      lastLogin: 'Dernière connexion',
      notLogged: 'Non connecté depuis',
    },
    statusFilter: {
      all: 'Tous les états',
      active: 'Actif',
      inactive: 'Inactif',
    },
    allAccesslevel: "Tous les niveaux d'accès",
  },
  cards: {
    table: {
      card: 'Identifiant',
      format: 'Format',
      username: "Nom d'utilisateur",
      activationDate: "Date d'activation",
      lastUsed: 'Dernière utilisation',
      status: 'Statut',
      assigned: 'Assigné',
      stolen: 'Volé',
      lost: 'Perdu',
      lockdown: 'Verrouillage',
      usedForAccess: "Utilisé pour l'accès",
    },
    cardSearch: 'Identifiant',
    usernameSearch: 'Utilisateur',
    cardStatusRadio: "Statut de l'identifiant",
    cardOptionsRadio: "Options de l'identifiant",
    allFormats: 'Tous les formats',
    cardStatusFilter: {
      all: 'Tous',
      active: 'Actif',
      inactive: 'Inactif',
    },
    cardAssignedFilter: {
      all: 'Tous',
      yes: 'Oui',
      no: 'Non',
    },
    dateFilter: {
      activation: "Date d'activation",
      lastUsed: 'Dernière utilisation',
      notUsed: 'Non utilisé en',
    },
  },
};

export default reports;
